
import axios from 'axios';

const API_URL_BASE          = 'https://api.atos.igarape.org.br/' //prod
//const API_URL_BASE          = 'https://hmg-api-atos.igarape.org/' //desenv

//const API_URL_BASE          = 'https://34.236.205.214/' //hmg

const API_URL_BASE_PREFIX   = 'api/v1/'
const API_URL_BASE_PREFIX2  = 'act';

const listActs          = '/list';
const resumeActChanges  = '/resume_changes';
const actText           = '/text';
const detail_changes    = '/detail_changes';
const analytics         = '/analytics';
const countActs         = '/count_acts';
const countActsTypeModifications = '/count_modifications';
const versions          = '/versions';

const API_URL_EMAIL = 'https://southamerica-east1-atos-web.cloudfunctions.net/sendmailatos'

export class APIService{

    constructor(){
       
    }

    getListActs(filterParams) {
        const url = API_URL_BASE + API_URL_BASE_PREFIX + API_URL_BASE_PREFIX2 + listActs + filterParams;
        return axios.get(url).then(response => response.data);
    }

    getResumeAct(filterParams) {
        const url = API_URL_BASE + API_URL_BASE_PREFIX + API_URL_BASE_PREFIX2 + resumeActChanges + filterParams;
        return axios.get(url).then(response => response.data);
    }
    getActText(filterParams){
        const url = API_URL_BASE + API_URL_BASE_PREFIX + API_URL_BASE_PREFIX2 + actText  + filterParams;
        return axios.get(url).then(response => response.data);
    }

    getDetailActChanges(filterParams) {
        const url = API_URL_BASE + API_URL_BASE_PREFIX + API_URL_BASE_PREFIX2 + detail_changes + filterParams;
        return axios.get(url).then(response => response.data);
    }

    getAnalytics(filterParams){
        const url = API_URL_BASE + API_URL_BASE_PREFIX + API_URL_BASE_PREFIX2 + analytics + countActs +filterParams;
        return axios.get(url).then(response => response.data);
    }

    getAnalyticsActTypeModifications(filterParams){
        const url = API_URL_BASE + API_URL_BASE_PREFIX + API_URL_BASE_PREFIX2 + analytics + countActsTypeModifications +filterParams;
        return axios.get(url).then(response => response.data);
    }

    getActVersions(filterParams){
        const url = API_URL_BASE + API_URL_BASE_PREFIX + API_URL_BASE_PREFIX2 + versions + filterParams;
        return axios.get(url).then(response => response.data);
    } 

    objectToQuerystring (obj) {
        return Object.keys(obj).reduce(function (str, key, i) {
            var delimiter, val;
            delimiter = (i === 0) ? '?' : '&';
            key = encodeURIComponent(key);
            val = encodeURIComponent(obj[key]);
            return [str, delimiter, key, '=', val].join('');
        }, '');
    }

  
    sendEmail(params){
        const url = API_URL_EMAIL + params
        return axios.get(url).then(response => response.data);
    }


}